import { FC, PropsWithChildren } from "react";

import __ from "web/Layout/Translations";

import FEATURE_FLAGS from "web/constants/featureFlags";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import classes from "./wrapperWithTitle.scss";

export const ROOM_OFFERS_ID = "roomOffers";

interface IProductWrapperWithTitleDesktopProps extends PropsWithChildren {
  showSupplierNotice?: boolean;
}

const ProductWrapperWithTitleDesktop: FC<IProductWrapperWithTitleDesktopProps> = ({
  children,
  showSupplierNotice = false,
}) => {
  const isSupplierInfoEnabled = useFeatureIsOn(FEATURE_FLAGS.SUPPLIER_INFO);

  return (
    <div
      id={ROOM_OFFERS_ID}
      className={classes.root}
      data-t1="room_offers"
      data-testid="room_offers"
    >
      <h2 className={classes.header}>
        {__("Oferty obiektu")}{" "}
        <small className={classes.header_small} data-t1="room_offers_desc">
          ({__("Sprawdź dostępne oferty dopasowane do Twoich filtrów")})
        </small>
      </h2>
      {isSupplierInfoEnabled && showSupplierNotice ? (
        <p
          className={classes.supplierNotice}
          data-t1="room_offers_supplier_notice"
        >
          {__(
            "Dostawca usługi realizowanej za Świadczenie (Przedsiębiorca) zostanie podany w kolejnym kroku."
          )}
        </p>
      ) : null}
      {children}
    </div>
  );
};

export default ProductWrapperWithTitleDesktop;
